// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, MenuItem } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { deleteCreditSegmentCode, getCreditSegmentCodeTable } from "../../features/creditSegmentCode";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";

const CreditSegmentCode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { creditSegmentCodes, status } = useSelector((state: any) => state.creditSegmentCode);

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this credit segment code?");
    if (isConfirmed) {
      dispatch(deleteCreditSegmentCode(id))
        .then((res) => {
          toast.success(res.payload.message);
          dispatch(getCreditSegmentCodeTable({ page: pageIndex, limit: pageSize }));
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Key",
      accessorKey: "key",
      id: "key",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Value",
      accessorKey: "value",
      id: "value",
      align: "left",
      cell: (info: any) => <span>{info.getValue() || "No value available"}</span>,
    },
    
        {
     header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        return (
          <div>
            <ActionMenu sx={{ width: "50px" }}>
              <MenuItem onClick={() => navigate(`/credit-segment/edit/${id}`)}>
              Edit
            </MenuItem>
            <MenuItem onClick={() => handleDelete(id)}>
              Delete
            </MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getCreditSegmentCodeTable({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    if (status && creditSegmentCodes && creditSegmentCodes?.data) {
      setData(creditSegmentCodes.data);
      setTotalRows(creditSegmentCodes.pagination.total || 0);
    }
  }, [status, creditSegmentCodes]);

  return (
    <DashboardLayout>
                  <DashboardNavbar />
      
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h4" fontWeight="bold">
                Credit Segment Codes
              </SoftTypography>
              <SoftButton onClick={() => navigate("/credit-segment/add")} variant="contained" color="final">
                Add Credit Segment Code
              </SoftButton>
            </SoftBox>
              <Table
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default CreditSegmentCode;
